import { Wifi, Coffee, Monitor, Users, Calendar, Shield } from 'lucide-react';

const features = [
  {
    icon: Wifi,
    title: 'High-Speed Internet',
    description: 'Lightning-fast fiber internet with backup connections for uninterrupted work.',
    color: 'text-[#1F473E]'
  },
  {
    icon: Coffee,
    title: 'Premium Amenities',
    description: 'Complimentary coffee, tea, and access to kitchen facilities.',
    color: 'text-[#49685E]'
  },
  {
    icon: Monitor,
    title: 'Modern Equipment',
    description: 'Meeting rooms with HD displays and video conferencing.',
    color: 'text-[#1F473E]'
  },
  {
    icon: Users,
    title: 'Community Events',
    description: 'Regular networking events, workshops, and social gatherings.',
    color: 'text-[#49685E]'
  },
  {
    icon: Calendar,
    title: 'Flexible Booking',
    description: 'Book desks and rooms on-demand through our mobile app.',
    color: 'text-[#1F473E]'
  },
  {
    icon: Shield,
    title: 'Secure Access',
    description: '24/7 secure access with smart locks and surveillance systems.',
    color: 'text-[#49685E]'
  }
];

export function Features() {
  return (
    <section id="features" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl text-[#1F473E] mb-4">Everything You Need</h2>
          <p className="text-xl text-[#49685E] max-w-2xl mx-auto">
            Premium amenities and services designed to help you focus on what matters most
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="p-6 border border-[#D8D7C8] rounded-lg hover:border-[#49685E] hover:shadow-lg hover:shadow-[#1F473E]/10 transition-all">
              <feature.icon className={`w-10 h-10 ${feature.color} mb-4`} />
              <h3 className="text-xl text-[#1F473E] mb-2">{feature.title}</h3>
              <p className="text-[#49685E]">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}